module.exports = __webpack_public_path__ + "static/media/photo229.2d7d83c4.jpg";